/** Fetch the complete history in bounded requests; no hidden age/count cutoff. */
export async function loadCustomerTicketHistory<T extends { id: string }>(
  fetchPage: (limit: number, offset: number) => Promise<T[]>,
  isCurrent: () => boolean = () => true,
): Promise<T[]> {
  const pageSize = 200
  const rows = new Map<string, T>()
  for (let offset = 0; isCurrent(); offset += pageSize) {
    const page = await fetchPage(pageSize, offset)
    for (const row of page) rows.set(row.id, row)
    if (page.length < pageSize) break
  }
  return [...rows.values()]
}
